<!--
  stitch-app-shell subtasks (Figma 295:95803, Johanna 2026-10-20): plain 40px rows, each a priority-coloured circle
  and its title, hover Gray/100; then "+ Add a new subtask", which opens an empty row at the end. No sort & filter
  icon (Johanna, 2026-10-21: removed).
-->
<div class="subtasks">
  @for (subtask of subtasks; track subtask) {
    <div class="subtasks-row">
      @if (subtask.pinned) {
        <mat-icon class="subtasks-row-pin-icon" svgIcon="pin-direct" />
      }

      <span class="subtasks-row-check">
        <app-circular-progress
          [progress]="subtask.progress"
          [size]="16"
          [priority]="subtask.priority"
          [completed]="subtask.completed"
          (onClick)="handleComplete(subtask)"
        />
      </span>

      <!--This section is hidden for V1-->
      @if (false) {
        <span class="subtasks-row-issue-key">{{ subtask | taskIssueKeyTitle }}</span>
      }
      <input
        class="subtasks-row-input"
        [class.completed]="subtask.completed"
        placeholder="Subtask"
        (keyup.enter)="blurTarget($event)"
        [value]="subtask.title"
        (focusout)="handleEditSubtask($event, subtask)"
      />

      <span class="subtasks-row-actions">
        <app-subtask-actions [subtask]="subtask" />

        <button
          type="button"
          class="subtasks-row-action"
          aria-label="Remove subtask"
          [disabled]="!(subtask.accountId | appCanPurgeTeamItem)"
          [matTooltip]="(subtask.accountId | appCanPurgeTeamItem) ? 'Remove subtask' : PURGE_REFUSED_REASON"
          [attr.aria-describedby]="
            (subtask.accountId | appCanPurgeTeamItem) ? null : 'subtask-purge-reason-' + subtask.id
          "
          (click)="handleDeleteSubtask(subtask)"
        >
          <app-icon name="trash" [size]="18" />
        </button>
        @if (!(subtask.accountId | appCanPurgeTeamItem)) {
          <span class="sr-only" [id]="'subtask-purge-reason-' + subtask.id">{{ PURGE_REFUSED_REASON }}</span>
        }
      </span>
    </div>
  }

  @for (pending of pendingSubtasks; track pending.id) {
    <div class="subtasks-row opacity-60">
      <span class="subtasks-row-check">
        <app-circular-progress [progress]="0" [size]="16" [completed]="false" />
      </span>
      <input class="subtasks-row-input" [value]="pending.title" disabled />
      <span class="subtasks-row-actions">
        <button
          type="button"
          class="subtasks-row-action"
          aria-label="Remove subtask"
          (click)="removePendingSubtask(pending.id)"
        >
          <app-icon name="trash" [size]="18" />
        </button>
      </span>
    </div>
  }

  @for (row of saving; track row) {
    <div class="subtasks-row">
      <span class="subtasks-row-check">
        <app-circular-progress [progress]="0" [size]="16" [completed]="false" />
      </span>
      <input class="subtasks-row-input" [value]="row.title" disabled aria-label="Saving subtask" />
    </div>
  }

  @if (adding) {
    <div class="subtasks-row subtasks-row-new">
      <span class="subtasks-row-check">
        <app-circular-progress [progress]="0" [size]="16" [completed]="false" />
      </span>
      <input
        #newSubtaskInput
        class="subtasks-row-input"
        placeholder="Subtask"
        aria-label="New subtask"
        [(ngModel)]="title"
        (keyup.enter)="handleEnterNew()"
        (keydown.escape)="cancelAdding()"
        (focusout)="handleAddBlur()"
      />
    </div>
  }

  <div class="subtasks-add">
    <button type="button" class="subtasks-add-link" (click)="startAdding()">
      <app-icon name="sapphire-plus" [size]="16" />
      Add a new subtask
    </button>
  </div>
</div>
